<template>
  <div class="gallery">
    <GalleryFilters :images="images"></GalleryFilters>
    <Gallery galleryID="gallery" :images="images"></Gallery>
  </div>
</template>

<script>
// @ is an alias to /src
import Gallery from "@/components/Gallery.vue";
import GalleryFilters from "@/components/GalleryFilters.vue";
import { images } from "@/assets/images_sfw.js";

export default {
  name: "SFWGalleryView",
  components: {
    Gallery,
    GalleryFilters,
  },
  data() {
    return {
      images,
    };
  },
};
</script>